import { memo } from 'react';

import AsideQuickView from 'shared/components/quick-view/AsideQuickView';
import OutputsOverview from 'shared/outputs/OutputsOverview';

const Overview = ({ isLoading, overview, measurementSystem, onMeasurementSystemChange, project }) => (
  <AsideQuickView
    title="Overview"
    isLoading={isLoading}
    measurementSystem={measurementSystem}
    onMeasurementSystemChange={onMeasurementSystemChange}
    withProjectName
    project={project}
  >
    <OutputsOverview overview={overview} project={project} />
  </AsideQuickView>
);

export default memo(Overview);
